import Spinner from "@/Components/Spinner/Spinner";
import { cn } from "@/shared/utils/cn";
import React from "react";
import Icon, { IconsVariant } from "../Icon/Icon";

type IconButtonVariant = "primary" | "secondary" | "danger" | "success";
type Size = "default" | "small" | "mini" | "big" | "bigger";
export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isDisabled?: boolean;
  variants?: IconsVariant;
  variant?: IconButtonVariant;
  size?: Size;
  ["date-tip"]?: string;
  isPending?: boolean;
  fill?: any;
  children?: React.ReactNode;
}

const IconButton = ({
  variant = "primary",
  variants,
  size = "default",
  isDisabled = false,
  isPending = false,
  fill,
  children,
  ...props
}: IconButtonProps) => {
  const sizeClassName = {
    default: "size-[3.25rem] md:size-[4rem]",
    small: "size-[3.25rem] md:size-[3.25rem]",
    mini: "size-[3.25rem] md:size-[2.25rem]",
    big: "size-[3.25rem] md:size-[3.75rem] lg:size-[4.25rem]",
    bigger: "size-[4.5rem] md:size-[4.25rem] lg:size-[4.75rem]",
  }[size];

  const iconSize = {
    default: "size-[1.8rem] md:size-[1.8rem]",
    small: "size-[1.8rem] md:size-[1.8rem]",
    mini: "size-[1.8rem] md:size-[1.1rem]",
    big: "size-[1.8rem] md:size-[2rem] lg:size-[2.25rem]",
    bigger: "size-[1.8rem] md:size-[2.25rem] lg:size-[2.5rem]",
  }[size];

  const variantClassName = isDisabled
    ? "bg-disabled text-grey"
    : {
        primary: "bg-primary text-white",
        secondary: "bg-white text-primary",
        danger: "bg-error text-white",
        success: "bg-success text-white",
      }[variant];

  const iconFill = isDisabled
    ? "fill-grey"
    : fill || (variant === "secondary" ? "fill-primary" : "fill-white");

  return (
    <button
      disabled={isPending || isDisabled}
      className={cn(
        "flex items-center justify-center rounded-full border-none font-black outline-none transition-all",
        sizeClassName,
        variantClassName,
        !isDisabled ? "cursor-pointer" : "cursor-auto"
      )}
      {...props}
    >
      {isPending ? (
        <div>
          <Spinner size="0.16rem" color="white" />
        </div>
      ) : children ? (
        children
      ) : (
        <Icon className={cn(iconSize, iconFill)} variants={variants} />
      )}
    </button>
  );
};

export default IconButton;
